var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle, _circle2, _path31, _circle3, _g, _circle4, _g2, _path32, _path33, _path34, _path35, _g3, _circle5, _g4, _circle6, _circle7, _circle8, _ellipse, _ellipse2, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _path36, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _circle31, _circle32, _circle33, _path37, _circle34, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIllustrationSecurityAndControl = function SvgIllustrationSecurityAndControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1522,
    height: 1320,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5CB198",
    d: "M780.23 465.613q.721.415 1.239 1.027.517.624.855 1.417a7.5 7.5 0 0 1 .496 1.755q.157.961.157 2.08 0 1.104-.157 1.885-.157.792-.496 1.196a1.11 1.11 0 0 1-.855.416q-.518.025-1.239-.39a4.6 4.6 0 0 1-1.238-1.04 5.5 5.5 0 0 1-.856-1.404 7.6 7.6 0 0 1-.495-1.768 13 13 0 0 1-.158-2.067q0-1.119.158-1.898.157-.78.495-1.183a1.15 1.15 0 0 1 .856-.429q.518-.014 1.238.403m0 .949q-.473-.273-.81-.26a.72.72 0 0 0-.541.299q-.213.266-.315.754a6 6 0 0 0-.101 1.189v1.482q0 .676.101 1.294.102.617.315 1.131.204.507.541.91.337.416.81.689t.811.247a.72.72 0 0 0 .552-.28q.202-.273.304-.773.1-.5.101-1.177v-1.482a8 8 0 0 0-.101-1.306 5.4 5.4 0 0 0-.304-1.112 3.8 3.8 0 0 0-.552-.929 3 3 0 0 0-.811-.676m0 2.977q.394.227.552.5.146.266.146.527v.286q0 .26-.146.357-.158.091-.552-.136-.393-.228-.54-.494a1.07 1.07 0 0 1-.158-.533v-.286q0-.261.158-.351.147-.098.54.13M1034.91 463.019c.48.277.89.62 1.24 1.027.34.416.63.888.85 1.417.23.529.39 1.114.5 1.755.1.641.16 1.335.16 2.08 0 .737-.06 1.365-.16 1.885-.11.529-.27.927-.5 1.196-.22.269-.51.407-.85.416-.35.017-.76-.113-1.24-.39a4.6 4.6 0 0 1-1.24-1.04 5.4 5.4 0 0 1-.85-1.404 7.6 7.6 0 0 1-.5-1.768c-.1-.641-.16-1.33-.16-2.067 0-.745.06-1.378.16-1.898.11-.52.27-.914.5-1.183.22-.269.51-.412.85-.429.35-.009.76.126 1.24.403m0 .949q-.48-.273-.81-.26a.7.7 0 0 0-.54.299c-.14.178-.25.429-.32.754-.06.334-.1.73-.1 1.19v1.482c0 .45.04.881.1 1.293.07.412.18.789.32 1.131q.195.507.54.91.33.416.81.689t.81.247a.7.7 0 0 0 .55-.28c.14-.181.24-.439.31-.773.06-.334.1-.726.1-1.176v-1.482c0-.46-.04-.895-.1-1.307a5.2 5.2 0 0 0-.31-1.111 3.5 3.5 0 0 0-.55-.93 2.9 2.9 0 0 0-.81-.676m0 2.977c.26.152.45.319.55.501q.15.266.15.526v.286q0 .26-.15.358c-.1.06-.29.015-.55-.137q-.39-.227-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.173.05-.29.16-.351q.15-.098.54.13M1004.38 576.011c.48.278.89.62 1.24 1.027.34.416.63.889.85 1.417.23.529.39 1.114.5 1.755.1.642.16 1.335.16 2.08 0 .737-.06 1.365-.16 1.885-.11.529-.27.928-.5 1.196-.22.269-.51.408-.85.416-.35.018-.76-.112-1.24-.39a4.6 4.6 0 0 1-1.24-1.04 5.8 5.8 0 0 1-.86-1.404 7.6 7.6 0 0 1-.49-1.768c-.11-.641-.16-1.33-.16-2.067 0-.745.05-1.378.16-1.898.1-.52.27-.914.49-1.183.23-.268.52-.411.86-.429.35-.008.76.126 1.24.403m0 .949q-.48-.273-.81-.26a.7.7 0 0 0-.54.299c-.14.178-.25.429-.32.754-.06.334-.1.73-.1 1.19v1.482c0 .45.04.882.1 1.293.07.412.18.789.32 1.131q.195.508.54.91.33.417.81.689.465.274.81.247a.71.71 0 0 0 .55-.279c.14-.182.24-.44.31-.774.06-.333.1-.726.1-1.176v-1.482c0-.46-.04-.895-.1-1.307a5.2 5.2 0 0 0-.31-1.111 3.8 3.8 0 0 0-.55-.93q-.345-.403-.81-.676m0 2.977c.26.152.45.319.55.501q.15.266.15.526v.286q0 .26-.15.358c-.1.06-.29.015-.55-.137q-.39-.227-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.173.05-.29.16-.351q.15-.097.54.13M1125.39 878.988c.48.277.89.619 1.24 1.027.34.416.63.888.85 1.417.23.528.39 1.113.5 1.755q.15.961.15 2.08 0 1.104-.15 1.885c-.11.528-.27.927-.5 1.196a1.1 1.1 0 0 1-.85.416c-.35.017-.76-.113-1.24-.39-.48-.278-.9-.624-1.24-1.04a5.5 5.5 0 0 1-.86-1.404 7.6 7.6 0 0 1-.49-1.768c-.11-.642-.16-1.331-.16-2.067 0-.746.05-1.378.16-1.898.1-.52.27-.915.49-1.183.23-.269.51-.412.86-.429.34-.009.76.125 1.24.403m0 .949q-.48-.273-.81-.26a.7.7 0 0 0-.54.299c-.15.177-.25.429-.32.754-.07.333-.1.73-.1 1.189v1.482c0 .451.03.882.1 1.294.07.411.17.788.32 1.131q.195.507.54.91.33.416.81.689.465.273.81.247a.71.71 0 0 0 .55-.28c.13-.182.24-.44.3-.773.07-.334.1-.726.1-1.177v-1.482c0-.459-.03-.895-.1-1.306a5.2 5.2 0 0 0-.3-1.112 3.8 3.8 0 0 0-.55-.929q-.345-.403-.81-.676m0 2.977c.26.151.44.318.55.5.1.178.14.353.14.527v.286c0 .173-.04.292-.14.357-.11.061-.29.015-.55-.136q-.405-.228-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.174.05-.291.16-.351q.135-.098.54.13M1137.28 592.691c.48.277.89.62 1.24 1.027.34.416.63.888.85 1.417.23.529.39 1.114.5 1.755q.15.962.15 2.08 0 1.105-.15 1.885c-.11.529-.27.927-.5 1.196-.22.269-.51.407-.85.416-.35.017-.76-.113-1.24-.39a4.5 4.5 0 0 1-1.24-1.04 5.5 5.5 0 0 1-.86-1.404 7.6 7.6 0 0 1-.49-1.768c-.11-.641-.16-1.33-.16-2.067 0-.745.05-1.378.16-1.898.1-.52.27-.914.49-1.183.23-.269.51-.412.86-.429.34-.009.76.126 1.24.403m0 .949q-.48-.273-.81-.26a.7.7 0 0 0-.54.299c-.15.178-.25.429-.32.754-.07.334-.1.73-.1 1.189v1.482c0 .451.03.882.1 1.294s.17.789.32 1.131q.195.507.54.91.33.416.81.689.465.273.81.247a.71.71 0 0 0 .55-.28c.13-.182.24-.439.3-.773.07-.334.1-.726.1-1.177v-1.482c0-.459-.03-.894-.1-1.306a5.2 5.2 0 0 0-.3-1.112 3.8 3.8 0 0 0-.55-.929q-.345-.403-.81-.676m0 2.977c.26.152.44.318.55.5q.15.267.15.527v.286q0 .26-.15.357c-.11.061-.29.016-.55-.136q-.405-.228-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.173.05-.29.16-.351q.135-.098.54.13M1023.61 749.98q.72.416 1.23 1.027c.35.416.63.888.86 1.417.22.529.39 1.114.49 1.755.11.641.16 1.335.16 2.08 0 .737-.05 1.365-.16 1.885-.1.529-.27.927-.49 1.196-.23.269-.51.407-.86.416q-.51.025-1.23-.39a4.5 4.5 0 0 1-1.24-1.04 5.5 5.5 0 0 1-.86-1.404 7.6 7.6 0 0 1-.49-1.768c-.11-.641-.16-1.33-.16-2.067 0-.745.05-1.378.16-1.898.1-.52.27-.914.49-1.183.23-.269.51-.412.86-.429.34-.009.76.126 1.24.403m0 .949c-.32-.182-.59-.269-.82-.26a.73.73 0 0 0-.54.299c-.14.178-.24.429-.31.754-.07.334-.1.73-.1 1.189v1.482c0 .451.03.882.1 1.294s.17.789.31 1.131q.21.507.54.91c.23.277.5.507.82.689q.465.273.81.247a.71.71 0 0 0 .55-.28q.195-.273.3-.773c.07-.334.1-.726.1-1.177v-1.482c0-.459-.03-.894-.1-1.306a6 6 0 0 0-.3-1.112 3.8 3.8 0 0 0-.55-.929q-.345-.403-.81-.676m0 2.977c.26.152.44.318.55.5.09.178.14.354.14.527v.286c0 .173-.05.292-.14.357-.11.061-.29.016-.55-.136q-.405-.227-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.173.05-.29.16-.351q.135-.098.54.13M1214.61 639.363c.48.277.9.619 1.24 1.027.35.416.63.888.86 1.417.22.528.39 1.113.49 1.755.11.641.16 1.334.16 2.08 0 .736-.05 1.365-.16 1.885-.1.528-.27.927-.49 1.196a1.12 1.12 0 0 1-.86.416c-.34.017-.76-.113-1.24-.39a4.7 4.7 0 0 1-1.24-1.04 5.5 5.5 0 0 1-.85-1.404 7.6 7.6 0 0 1-.5-1.768q-.15-.963-.15-2.067 0-1.119.15-1.898c.11-.52.27-.915.5-1.183.22-.269.51-.412.85-.429.35-.009.76.125 1.24.403m0 .949q-.465-.273-.81-.26a.73.73 0 0 0-.54.299c-.14.177-.25.429-.31.754-.07.333-.1.73-.1 1.189v1.482c0 .451.03.882.1 1.294.06.411.17.788.31 1.131q.21.507.54.91.345.416.81.689.48.273.81.247a.73.73 0 0 0 .56-.28q.195-.273.3-.773c.07-.334.1-.726.1-1.177v-1.482c0-.459-.03-.895-.1-1.306a6 6 0 0 0-.3-1.112 3.9 3.9 0 0 0-.56-.929 2.9 2.9 0 0 0-.81-.676m0 2.977c.27.151.45.318.55.5q.15.266.15.527v.286q0 .26-.15.357c-.1.061-.28.015-.55-.136q-.39-.228-.54-.494-.15-.273-.15-.533v-.286q0-.261.15-.351.15-.098.54.13M1193.86 744.746q.72.415 1.23 1.027c.35.416.63.888.86 1.417.22.528.39 1.113.49 1.755.11.641.16 1.334.16 2.08 0 .736-.05 1.365-.16 1.885-.1.528-.27.927-.49 1.196a1.12 1.12 0 0 1-.86.416q-.51.025-1.23-.39c-.48-.278-.9-.624-1.24-1.04a5.5 5.5 0 0 1-.86-1.404 7.6 7.6 0 0 1-.49-1.768c-.11-.642-.16-1.331-.16-2.067 0-.746.05-1.378.16-1.898.1-.52.27-.915.49-1.183.23-.269.51-.412.86-.429.34-.009.76.125 1.24.403m0 .949c-.32-.182-.59-.269-.82-.26a.73.73 0 0 0-.54.299c-.14.177-.24.429-.31.754-.07.333-.1.73-.1 1.189v1.482c0 .451.03.882.1 1.294.07.411.17.788.31 1.131q.21.507.54.91c.23.277.5.507.82.689q.465.273.81.247a.71.71 0 0 0 .55-.28q.195-.273.3-.773c.07-.334.1-.726.1-1.177v-1.482c0-.459-.03-.895-.1-1.306a6 6 0 0 0-.3-1.112 3.8 3.8 0 0 0-.55-.929q-.345-.403-.81-.676m0 2.977c.26.151.44.318.55.5.09.178.14.353.14.527v.286c0 .173-.05.292-.14.357-.11.061-.29.015-.55-.136q-.405-.228-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.174.05-.291.16-.351q.135-.098.54.13M1079.36 671.816q.72.416 1.23 1.027c.35.416.63.888.86 1.417.22.529.39 1.114.49 1.755.11.641.16 1.335.16 2.08 0 .737-.05 1.365-.16 1.885-.1.529-.27.927-.49 1.196-.23.269-.51.407-.86.416q-.51.026-1.23-.39a4.5 4.5 0 0 1-1.24-1.04 5.5 5.5 0 0 1-.86-1.404 7.6 7.6 0 0 1-.49-1.768c-.11-.641-.16-1.33-.16-2.067 0-.745.05-1.378.16-1.898.1-.52.27-.914.49-1.183.23-.269.51-.412.86-.429.34-.009.76.126 1.24.403m0 .949c-.32-.182-.59-.269-.82-.26a.73.73 0 0 0-.54.299c-.14.178-.24.429-.31.754-.07.334-.1.73-.1 1.189v1.482c0 .451.03.882.1 1.294s.17.789.31 1.131q.21.507.54.91c.23.277.5.507.82.689q.465.273.81.247a.71.71 0 0 0 .55-.28q.195-.273.3-.773c.07-.334.1-.726.1-1.177v-1.482c0-.459-.03-.894-.1-1.306a6 6 0 0 0-.3-1.112 3.8 3.8 0 0 0-.55-.929q-.345-.403-.81-.676m0 2.977c.26.152.44.318.55.5.09.178.14.354.14.527v.286c0 .173-.05.292-.14.357-.11.061-.29.016-.55-.136q-.405-.228-.54-.494a1 1 0 0 1-.16-.533v-.286c0-.173.05-.29.16-.351q.135-.098.54.13M1043.62 692.269c.48.277.89.62 1.24 1.027.34.416.63.888.86 1.417.22.529.39 1.114.49 1.755.11.641.16 1.335.16 2.08 0 .737-.05 1.365-.16 1.885-.1.529-.27.927-.49 1.196-.23.269-.52.407-.86.416-.35.017-.76-.113-1.24-.39a4.6 4.6 0 0 1-1.24-1.04 5.4 5.4 0 0 1-.85-1.404 7.6 7.6 0 0 1-.5-1.768c-.1-.641-.16-1.33-.16-2.067 0-.745.06-1.378.16-1.898.11-.52.27-.914.5-1.183.22-.269.51-.412.85-.429.35-.009.76.126 1.24.403m0 .949q-.465-.273-.81-.26a.73.73 0 0 0-.54.299c-.14.178-.25.429-.32.754-.06.334-.1.73-.1 1.19v1.482c0 .45.04.881.1 1.293.07.412.18.789.32 1.131q.21.507.54.91.345.416.81.689.48.273.81.247a.7.7 0 0 0 .55-.28c.14-.181.24-.439.31-.773.06-.334.1-.726.1-1.176v-1.482c0-.46-.04-.895-.1-1.307a5.2 5.2 0 0 0-.31-1.111 3.5 3.5 0 0 0-.55-.93 2.9 2.9 0 0 0-.81-.676m0 2.977c.26.152.45.319.55.501q.15.266.15.526v.286q0 .26-.15.358c-.1.06-.29.015-.55-.137q-.39-.228-.54-.494c-.1-.182-.16-.36-.16-.533v-.286c0-.173.06-.29.16-.351q.15-.098.54.13M1025.39 379.803v-.95l2.25 1.301v-7.32l-.08-.045-1.98.988-.56-1.008 2.09-1.046 1.47.851v8.126l2.07 1.196v.949zM932.791 527.045v-.949l2.252 1.3v-7.319l-.079-.046-1.981.988-.552-1.007 2.083-1.047 1.475.852v8.125l2.071 1.196v.949zM1174.29 479.396v-.949l2.25 1.3v-7.319l-.08-.045-1.98.988-.55-1.008 2.08-1.046 1.48.851v8.125l2.07 1.196v.949zM1319.46 353.803v-.95l2.25 1.301v-7.32l-.08-.045-1.98.988-.55-1.008 2.08-1.046 1.47.851v8.126l2.07 1.196v.949zM1044.42 743.756v-.949l2.26 1.3v-7.319l-.08-.046-1.98.988-.56-1.007 2.09-1.047 1.47.852v8.125l2.07 1.196v.949zM1151.08 773.498v-.949l2.25 1.3v-7.319l-.08-.046-1.98.988-.55-1.007 2.08-1.047 1.48.852v8.125l2.07 1.196v.949z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__b)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m926.43 858.455 575.16-331.798"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__c)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "M1205 743.502c224.61-129.575 92.56-53.339 317.17-182.915"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__d)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "M947.016 892.382 1145 778"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__e)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1223.5 640.252 254.92-146.665"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1057.66 735.718 134.59-77.716"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__f)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m950.125 797.463 61.745-35.503"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__g)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1191 471.502 198.9-115.095"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1022.15 569.17 120.35-70.169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__h)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1143.59 872.725 367.75-212.766"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__i)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m906.617 635.939 78.49-45.164"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__j)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m957.844 980.255 148.696-85.925"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__k)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1045.25 367.755 329.12-190.645"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__l)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "M744 542.075 1007.96 389"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__m)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m801 458.514 543.72-316.513"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__n)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m693.773 521.922 64.831-37.561"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__o)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1093.91 667.583 303.98-175.626"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__p)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m952.406 749.644 72.554-42.186",
    opacity: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__q)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m855.711 617.15 449.699-258.544"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__r)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "M1332 343.612 1407.5 300"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__s)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m655.555 502.667 676.475-392.416"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1150.12 588.622 172.75-99.841"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__t)",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m952.922 702.826 167.348-96.71"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__u)",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m953.703 935.664 340.107-196.811"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m1052.52 457.909 346.4-200.145"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__v)",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.3,
    d: "m825.609 589.103 94.417-54.534"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m947.813 518.363 68.947-39.879"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__w)",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m944.719 660.111 539.611-311.435"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__x)",
    strokeDasharray: "4 4",
    strokeMiterlimit: 10,
    strokeOpacity: 0.5,
    d: "m782.898 565.955 599.552-345.354"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    d: "m684.727 483.234-34.25 18.75 283 163v329l34-19.25v-328.75z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.072,
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.2,
    transform: "matrix(-.86603 -.5 0 1 942.539 659.43)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.9,
    opacity: 0.2,
    transform: "matrix(0 -1 -.86603 -.5 945.273 819.023)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    d: "M946.609 794.258v-5.053l-51.539-29.756v5.053zM946.602 784.086v-5.053l-51.539-29.756v5.053zM946.602 814.586v-5.053l-51.539-29.756v5.053zM946.609 773.922v-5.053l-51.539-29.756v5.053zM946.609 804.422v-5.053l-51.539-29.756v5.053z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "illustration-security-and-control_svg__y",
    width: 50,
    height: 64,
    x: 809,
    y: 586,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.9,
    transform: "matrix(-.86603 -.5 0 1 858.344 603.828)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__z)",
    mask: "url(#illustration-security-and-control_svg__y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__D)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#D2D6DB",
    transform: "matrix(-.86603 -.5 0 1 855.828 587.273)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__E)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 855.828 599.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 845.438 593.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 835.047 587.273)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__F)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 855.828 611.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 845.438 605.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 835.047 599.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 824.648 593.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 814.258 587.273)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__G)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 855.828 623.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 845.438 617.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 835.047 611.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 824.648 605.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 814.258 599.273)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__H)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 855.828 635.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 845.438 629.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 835.047 623.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 824.648 617.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 814.258 611.273)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__I)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 855.828 647.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 845.438 641.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 835.047 635.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 824.648 629.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 814.258 623.273)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__J)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 835.047 647.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 824.648 641.273)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 814.258 635.273)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__K)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#D2D6DB",
    transform: "matrix(-.86603 -.5 0 1 814.258 647.273)"
  }))))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    stroke: "#fff",
    strokeDasharray: "4 4",
    strokeWidth: 0.9,
    opacity: 0.2,
    transform: "matrix(-.86603 -.5 0 1 943.859 865.836)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 57.957,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 719.734 587.297)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 55.998,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 723.75 592.562)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 52.226,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 728.016 597.688)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 46.206,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 733.305 602.234)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 52.226,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 714.875 574.922)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 46.206,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 713.578 568.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 36.123,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 713.359 560.609)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 15.954,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 716.164 551.398)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 36.123,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 739.656 606.148)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 15.954,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 749.023 608.328)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 55.998,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 717.18 581.172)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.572,
    fill: "#14141C",
    stroke: "#fff",
    transform: "matrix(-.86603 -.5 0 1 757.086 553.172)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "M0-.5h314.122",
    opacity: 0.5,
    transform: "matrix(0 1 .86603 .5 876.773 594.211)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "M0-.5h314.122",
    opacity: 0.5,
    transform: "matrix(0 1 .86603 .5 786.078 541.836)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "m696.383 699.582 270.679 156.359M696.383 594.781l270.304 156.092M934.25 665.75l34-19.5M841.625 611.438l32.438-18.876M933.805 772.031l33.14-18.906M934.25 878.82 967 860.062M751.633 559.609 783.813 541",
    opacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    fillOpacity: 0.9,
    d: "M933.383 665.32 650.479 501.985v329.624l282.904 163.335z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "M0-.5h314.122",
    transform: "matrix(0 1 .86603 .5 837.438 616.969)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "M0-.5h314.122",
    transform: "matrix(0 1 .86603 .5 746.742 564.594)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "M0-.5h314.19",
    transform: "matrix(.86603 .5 0 -1 656.047 721.836)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C0C0",
    d: "M0-.5h314.19",
    transform: "matrix(.86603 .5 0 -1 656.047 617.031)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 318.666,
    height: 2.915,
    x: -0.433,
    y: 0.25,
    stroke: "#fff",
    rx: 1.457,
    transform: "matrix(-.86603 -.5 0 1 929.215 666.823)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 318.666,
    height: 2.915,
    x: -0.433,
    y: 0.25,
    stroke: "#fff",
    rx: 1.457,
    transform: "matrix(-.86603 -.5 0 1 929.208 984.877)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-security-and-control_svg__ag",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.609 510.013c0-.775-.544-1.718-1.215-2.105-.671-.388-1.216-.074-1.216.701v320.566l2.431 1.403z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M656.475 510.513c0-1.328-.932-2.942-2.081-3.605-1.15-.664-2.082-.126-2.082 1.201l1.732 1c0-.223.157-.313.35-.201a.77.77 0 0 1 .349.605zm-3.297 318.662 2.431 1.403zm3.297 1.903V510.513c0-1.328-.932-2.942-2.081-3.605v2a.77.77 0 0 1 .349.605v320.565zm-2.081-324.17c-1.15-.664-2.082-.126-2.082 1.201v320.566l1.732 1V509.109c0-.223.157-.313.35-.201z",
    mask: "url(#illustration-security-and-control_svg__ag)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-security-and-control_svg__ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930.023 668.443c0-.776-.544-1.718-1.215-2.106s-1.216-.073-1.216.702v320.565l2.431 1.404z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M930.889 668.943c0-1.328-.931-2.942-2.081-3.606s-2.082-.125-2.082 1.202l1.732 1c0-.223.157-.313.35-.202a.77.77 0 0 1 .349.606zm-3.297 318.661 2.431 1.404zm3.297 1.904V668.943c0-1.328-.931-2.942-2.081-3.606v2a.77.77 0 0 1 .349.606v320.565zm-2.081-324.171c-1.15-.663-2.082-.125-2.082 1.202v320.565l1.732 1V667.539c0-.223.157-.313.35-.202z",
    mask: "url(#illustration-security-and-control_svg__ah)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "illustration-security-and-control_svg__ai",
    width: 50,
    height: 64,
    x: 766,
    y: 611,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.9,
    transform: "matrix(-.86603 -.5 0 1 815.336 628.742)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__aj)",
    mask: "url(#illustration-security-and-control_svg__ai)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__an)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#D2D6DB",
    transform: "matrix(-.86603 -.5 0 1 812.82 612.188)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__ao)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 812.82 624.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 802.43 618.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 792.039 612.188)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__ap)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 812.82 636.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 802.43 630.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 792.039 624.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 781.641 618.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 771.25 612.188)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__aq)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 812.82 648.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 802.43 642.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 792.039 636.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 781.641 630.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 771.25 624.188)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__ar)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 812.82 660.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 802.43 654.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 792.039 648.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 781.641 642.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 771.25 636.188)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__as)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 812.82 672.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 802.43 666.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 792.039 660.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 781.641 654.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 771.25 648.188)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D2D6DB",
    clipPath: "url(#illustration-security-and-control_svg__at)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 792.039 672.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 781.641 666.188)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-.86603 -.5 0 1 771.25 660.188)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-security-and-control_svg__au)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#D2D6DB",
    transform: "matrix(-.86603 -.5 0 1 771.25 672.188)"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.072,
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.8,
    transform: "matrix(-.86603 -.5 0 1 905.852 680.992)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    stroke: "#fff",
    strokeWidth: 0.9,
    transform: "matrix(.61237 -.35355 -.61237 -1.06066 790.844 786.766)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.807,
    cy: 13.807,
    r: 9.807,
    stroke: "#fff",
    strokeWidth: 8,
    transform: "matrix(.61237 -.35355 -.61237 -1.06066 790.844 766.586)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 803.682,
    cy: 769.302,
    fill: "#fff",
    rx: 1.893,
    ry: 3.278,
    transform: "matrix(-.86603 .28868 -.86603 -.86603 2165.93 1203.53)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 778.112,
    cy: 725.029,
    fill: "#fff",
    rx: 1.893,
    ry: 3.278,
    transform: "matrix(-.86603 .28868 -.86603 -.86603 2079.87 1128.3)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 702.852 681.064)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 684.188 670.291)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 721.508 691.838)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 684.188 682.752)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 721.516 704.307)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 684.188 695.221)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 721.516 716.775)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 712.18 680.221)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 712.18 692.682)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 712.18 705.158)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 712.172 717.947)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 693.516 669.439)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 693.516 681.908)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 693.516 694.385)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 693.516 707.174)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 702.852 693.541)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 702.852 706.018)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 702.852 718.486)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.119,
    cy: 3.119,
    r: 3.119,
    fill: "#fff",
    transform: "matrix(-.86603 -.5 0 1 702.844 668.58)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.572,
    fill: "#14141C",
    stroke: "#fff",
    transform: "matrix(-.61237 -1.06066 -.61237 .35355 826.945 869.609)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.422,
    fill: "#14141C",
    stroke: "#fff",
    strokeWidth: 1.3,
    transform: "matrix(-.61237 -1.06066 -.61237 .35355 831.555 877.609)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.9,
    opacity: 0.8,
    transform: "matrix(0 -1 -.86603 -.5 905.984 842.156)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    d: "M907.32 817.391v-5.053l-51.539-29.756v5.053zM907.312 807.219v-5.053l-51.539-29.756v5.053zM907.312 837.719v-5.053l-51.539-29.756v5.053zM907.32 797.055v-5.053l-51.539-29.756v5.053zM907.32 827.555v-5.053l-51.539-29.756v5.053z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 57.957,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 686.039 606.547)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 55.998,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 690.055 611.812)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 52.226,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 694.32 616.938)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 46.206,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 699.609 621.484)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 52.226,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 681.18 594.172)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 46.206,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 679.883 587.32)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 36.123,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 679.664 579.859)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 15.954,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 682.469 570.648)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 36.123,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 705.961 625.398)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 15.954,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 715.328 627.578)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.466,
    height: 55.998,
    fill: "#fff",
    opacity: 0.8,
    rx: 1.233,
    transform: "matrix(.61237 1.06066 .61237 -.35355 683.484 600.422)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.572,
    fill: "#14141C",
    stroke: "#fff",
    transform: "matrix(-.86603 -.5 0 1 723.391 574.422)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    stroke: "#fff",
    strokeDasharray: "4 4",
    strokeWidth: 0.9,
    transform: "matrix(-.86603 -.5 0 1 905.852 890.875)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.654,
    cy: 19.654,
    r: 19.204,
    fill: "#fff",
    fillOpacity: 0.4,
    stroke: "#fff",
    strokeWidth: 0.9,
    opacity: 0.8,
    transform: "matrix(-.86603 -.5 0 1 717.172 790.055)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M651 502.5v329l282.75 162.062"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.072,
    cy: 28.072,
    r: 27.622,
    stroke: "#fff",
    strokeWidth: 0.9,
    transform: "matrix(-.86603 -.5 0 1 724.461 785.852)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m804.029 871.462 2.924-1.688-6.867-11.895 6.867-3.964-2.924-5.065-6.867 3.965-6.863-11.887-2.924 1.688 6.863 11.887-6.863 3.962 2.924 5.065 6.863-3.962z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m889.658 898.273 2.842 4.923-14.456 8.346-2.842-4.923.078-.044-3.26-5.646 2.842-1.641 3.26 5.646zM708.455 794.172l2.842 4.922-14.456 8.347-2.842-4.923.077-.045-3.259-5.645 2.842-1.641 3.259 5.646zm1.928-205.469-2.842-4.922-11.537 6.661-3.259-5.646-2.842 1.641 3.259 5.645-.077.045 2.842 4.922z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m887.205 688.594 2.842 4.922-6.671 3.852 6.671 11.554-2.842 1.641-6.671-11.554-6.674 3.853-2.842-4.923 6.674-3.853-6.674-11.559 2.842-1.641 6.674 11.559z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    fillRule: "evenodd",
    d: "m887.283 791.93 2.873 4.977-6.745 3.894 6.745 11.684-2.873 1.659-6.746-11.684-6.747 3.896-2.873-4.977 6.747-3.896-6.747-11.686 2.873-1.659 6.747 11.686z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m887.283 791.93 2.873 4.977-6.745 3.894 6.745 11.684-2.873 1.659-6.746-11.684-6.747 3.896-2.873-4.977 6.747-3.896-6.747-11.686 2.873-1.659 6.747 11.686z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    fillRule: "evenodd",
    d: "m798.021 632.913 3.104 5.376-7.287 4.207 7.287 12.621-3.104 1.792-7.287-12.622-7.287 4.208-3.104-5.376 7.288-4.207-7.288-12.622 3.104-1.792 7.287 12.622z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m798.021 632.913 3.104 5.376-7.287 4.207 7.287 12.621-3.104 1.792-7.287-12.622-7.287 4.208-3.104-5.376 7.288-4.207-7.288-12.622 3.104-1.792 7.287 12.622z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aQ)",
    d: "M2.398 1316.98 799.78 855.39"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aR)",
    d: "M.398 1314.98 797.78 853.39"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aS)",
    d: "m355.422 997.436 524.369-302.64"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aT)",
    d: "m357.422 999.436 524.369-302.64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aU)",
    d: "m267.422 941.332 524.369-302.639"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aV)",
    d: "m269.422 943.334 524.369-302.639"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aW)",
    d: "m143.398 1223.47 736.194-425.219"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-security-and-control_svg__aX)",
    d: "m145.398 1225.47 736.194-425.219"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    stroke: "#fff",
    d: "m966.977 974.443-33 18.684V664.695l-.251-.144-282.228-162.556 33.222-18.187 282.257 162.465z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.398.473h1521v1319H.398z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 719.273-623.088-359.74v155.519l623.088 359.74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 719.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 731.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__C"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 743.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__D"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 755.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 767.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__F"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 779.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__G"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 791.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 803.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__I"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 815.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__J"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 827.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__K"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 839.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__L"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 851.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__M"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 863.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 875.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__O"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 887.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__P"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 899.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__Q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 911.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__R"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 923.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 935.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__T"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 947.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__U"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 959.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__V"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 971.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__W"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 983.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__X"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 995.273-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__Y"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1007.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__Z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1019.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1031.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ab"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1043.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ac"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1055.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ad"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1067.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ae"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1079.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__af"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1146.81 1091.27-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aj"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 744.188-623.088-359.74v155.519l623.088 359.74z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ak"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 744.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__al"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 756.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__am"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 768.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__an"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 780.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ao"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 792.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ap"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 804.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aq"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 816.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ar"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 828.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__as"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 840.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__at"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 852.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__au"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 864.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__av"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 876.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aw"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 888.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ax"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 900.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__ay"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 912.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__az"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 924.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 936.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aB"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 948.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aC"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 960.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aD"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 972.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aE"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 984.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aF"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 996.188-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aG"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1008.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aH"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1020.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aI"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1032.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aJ"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1044.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aK"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1056.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1068.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aM"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1080.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aN"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1092.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aO"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1104.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-security-and-control_svg__aP"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1103.8 1116.19-781.155-451v12l781.155 451z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__b",
    x1: 926.43,
    x2: 1501.59,
    y1: 858.589,
    y2: 858.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__c",
    x1: 1205,
    x2: 1522.17,
    y1: 743.604,
    y2: 743.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__d",
    x1: 947.016,
    x2: 1145,
    y1: 892.344,
    y2: 892.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__e",
    x1: 1223.5,
    x2: 1478.42,
    y1: 640.508,
    y2: 640.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__f",
    x1: 950.125,
    x2: 1011.87,
    y1: 797.535,
    y2: 797.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__g",
    x1: 1191,
    x2: 1389.9,
    y1: 471.373,
    y2: 471.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__h",
    x1: 1143.59,
    x2: 1511.34,
    y1: 872.504,
    y2: 872.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__i",
    x1: 906.617,
    x2: 985.107,
    y1: 636.016,
    y2: 636.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__j",
    x1: 957.844,
    x2: 1106.54,
    y1: 980.218,
    y2: 980.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__k",
    x1: 1045.25,
    x2: 1374.37,
    y1: 367.441,
    y2: 367.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__l",
    x1: 744,
    x2: 1007.96,
    y1: 541.735,
    y2: 541.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__m",
    x1: 801,
    x2: 1344.72,
    y1: 457.215,
    y2: 457.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__n",
    x1: 693.773,
    x2: 758.604,
    y1: 521.856,
    y2: 521.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__o",
    x1: 1093.91,
    x2: 1397.89,
    y1: 667.523,
    y2: 667.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__p",
    x1: 872.171,
    x2: 1397.89,
    y1: 795.451,
    y2: 795.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__q",
    x1: 855.711,
    x2: 1305.41,
    y1: 617.696,
    y2: 617.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__r",
    x1: 1332,
    x2: 1407.5,
    y1: 343.602,
    y2: 343.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__s",
    x1: 655.555,
    x2: 1332.03,
    y1: 501.741,
    y2: 501.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#F5C0C0",
    stopOpacity: 0.884
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F5C0C0",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__t",
    x1: 952.922,
    x2: 1120.27,
    y1: 702.781,
    y2: 702.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__u",
    x1: 902,
    x2: 1294.55,
    y1: 967.002,
    y2: 965.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__v",
    x1: 825.609,
    x2: 920.026,
    y1: 589.091,
    y2: 589.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__w",
    x1: 781,
    x2: 1485.33,
    y1: 757.002,
    y2: 755.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__x",
    x1: 599,
    x2: 1383.52,
    y1: 675.002,
    y2: 673.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aQ",
    x1: 152.372,
    x2: 475.436,
    y1: 1230.96,
    y2: 668.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F5C0C0",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aR",
    x1: 150.372,
    x2: 473.436,
    y1: 1228.96,
    y2: 666.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F5C0C0",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aS",
    x1: 359.52,
    x2: 618.571,
    y1: 997.528,
    y2: 545.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aT",
    x1: 361.52,
    x2: 620.571,
    y1: 999.528,
    y2: 547.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aU",
    x1: 271.52,
    x2: 530.571,
    y1: 941.424,
    y2: 489.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aV",
    x1: 273.52,
    x2: 532.571,
    y1: 943.426,
    y2: 491.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aW",
    x1: 263.377,
    x2: 571.784,
    y1: 1152.97,
    y2: 620.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F5C0C0",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-security-and-control_svg__aX",
    x1: 265.377,
    x2: 573.784,
    y1: 1154.97,
    y2: 622.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F5C0C0",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5C0C0",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89898D"
  })))));
};
export { SvgIllustrationSecurityAndControl as ReactComponent };
export default __webpack_public_path__ + "static/illustration-security-and-control.3cf0081a.svg";